@if (content) {
  <div
    class="contacto-atencion"
    [class.contacto-atencion--page]="variant === 'page'"
    [class.contacto-atencion--modal]="variant === 'modal'"
  >
    @if (showTitle) {
      <h1 class="contacto-atencion__title">{{ content.title }}</h1>
    }

    <ul class="contacto-atencion__list">
      @for (item of content.items; track item.label) {
        <li class="contacto-atencion__item">
          <strong class="contacto-atencion__label">{{ item.label }}</strong>
          @if (item.href) {
            <a class="contacto-atencion__value contacto-atencion__value--link" [href]="item.href">
              {{ item.value }}
            </a>
          } @else {
            <p class="contacto-atencion__value">{{ item.value }}</p>
          }
        </li>
      }
    </ul>
  </div>
}
